<div class="alert-container" [class]="type">
  <i class="fas fa-circle-info"></i>
  <div class="content">
    <span>{{title}}</span>
    <p>{{message}}</p>
    <a *ngIf="messageAction" (click)="emitAction()">
      <i *ngIf="actionIcon" class="fas {{actionIcon}}"></i>
      {{messageAction}}
    </a>
  </div>
</div>